<template>
    <div>
        <div><strong>{{name}}</strong></div>
        <div><i>{{email}}</i></div>
        <div v-html="about"></div>
    </div>
</template>

<script>
export default {
    name:"committee",
    props:{
        name: String,
        email: String,
        about: String
    }
}
</script>